import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {baseUrl} from '../PatUniv.js'
const BillDetailsPat = (props) => {
    const pat_id = localStorage.getItem('pat_id');
    const [rows, setRows] = useState([]);
    const [rows1, setRows1] = useState([]);
    const [patientData, setPatientData] = useState([]);
    const [combinedData, setCombinedData] = useState([]);
    useEffect(() => {
        if (combinedData.length > 0) {
            setRows(combinedData);
        }
    }, [combinedData]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response1 = await axios.get(`${baseUrl}pat-search-view/${pat_id}/`);
                if (response1.status === 200 || response1.status === 201) {
                    setPatientData(response1.data);
                    const patId = response1.data[0].id;
                    const response2 = await axios.get(`${baseUrl}pat-emr-lab-op/${patId}/`);
                    const labData = response2.data.map(data => ({...data, type: 'lab'}));
                    const response3 = await axios.get(`${baseUrl}pat-emr-inv-op/${patId}/`);
                    const invData = response3.data.map(data => ({...data, type: 'inv'}));
                    const response4 = await axios.get(`${baseUrl}pat-emr-min-op/${patId}/`);
                    const minData = response4.data.map(data => ({...data, type: 'min'}));
                    const response5 = await axios.get(`${baseUrl}pat-emr-op/${patId}/`);
                    const opData = response5.data.map(data => ({...data, type: 'op'}));
                    const response6 = await axios.get(`${baseUrl}pat-fetch-ip-status/${patId}/`);
                    const ipData = response6.data.map((data) => ({
                        id: data.id,
                        ip_id: data.ip_id,
                        pat__pat_id: data.pat.pat_id,
                        pat__patient: data.pat.patient,
                        pat__age: data.pat.age,
                        pat__mobile: data.pat.mobile,
                        pat__address1: data.pat.address1,
                        room_no__room_no: data.room_no.room_no,
                        payment: data.payment,
                        admit_date: data.admit_date,
                        discharge_time: data.discharge_time,
                        action: '',
                        summary: '',
                    }));
                    setRows1(ipData);
                    const combined = [...invData, ...labData, ...minData, ...opData];
                    setRows(combined);
                } else {
                    window.location.href = '/pat-menu/';
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [pat_id]);
    const columns = [
        {field: 'add_date', headerName: 'Appt Date', width: 100},
        {
            field: 'test_name',
            headerName: 'Test Name',
            width: 200,
            renderCell: (params) => (
                params.row.lab_test ||
                params.row.inv_test ||
                params.row.min_test ||
                'OP Consult Fee'
            ),
        },
        {
            field: 'invoice',
            headerName: 'Invoice No',
            width: 120,
            renderCell: (params) => (
                params.row.lab_invoice ||
                params.row.inv_invoice ||
                params.row.min_invoice ||
                params.row.invoice
            ),
        },
        {
            field: 'invoice_amount',
            headerName: 'Invoice Amount',
            width: 120,
            renderCell: (params) => (
                params.row.lab_tot ||
                params.row.inv_tot ||
                params.row.min_tot ||
                params.row.fee
            ),
        },
        {
            field: 'paid_amount',
            headerName: 'Paid Amount',
            width: 120,
            renderCell: (params) => (
                params.row.lab_paid ||
                params.row.inv_paid ||
                params.row.min_paid ||
                params.row.paid
            ),
        },
        {
            field: 'disc_amount',
            headerName: 'Disc Amount',
            width: 120,
            renderCell: (params) => (
                params.row.lab_disc ||
                params.row.inv_disc ||
                params.row.min_disc ||
                '0'
            ),
        },
        {
            field: 'bal_amount',
            headerName: 'Balance Amount',
            width: 120,
            renderCell: (params) => (
                params.row.lab_balance ||
                params.row.inv_balance ||
                params.row.min_balance ||
                params.row.balance
            ),
        },
        {
            field: 'mode',
            headerName: 'Mode',
            width: 120,
            renderCell: (params) => (
                params.row.lab_pmode ||
                params.row.inv_pmode ||
                params.row.min_pmode ||
                params.row.mode
            ),
        },
        {
            field: 'addedby',
            headerName: 'Added by',
            width: 100,
        },
    ];
    const columns1 = [
        {
            field: 'ip_id',
            headerName: 'IP ID',
            renderCell: (params) => (
                <Link to={`/ip-pat-view/${params.row.id}/`}>{params.value}</Link>
            ),
            width: 100,
        },
        {field: 'pat__pat_id', headerName: 'Pat Id', width: 40},
        {field: 'pat__patient', headerName: 'Patient', width: 150},
        {field: 'pat__age', headerName: 'Age', width: 50},
        {field: 'pat__mobile', headerName: 'Mobile', width: 120},
        {field: 'pat__address1', headerName: 'Address', width: 220},
        {field: 'room_no__room_no', headerName: 'Room No', width: 75},
        {field: 'payment', headerName: 'Payment', width: 100},
        {field: 'admit_date', headerName: 'Admitted On', width: 120},
        {field: 'discharge_time', headerName: 'Discharged On', width: 120},
        {
            field: 'summary',
            headerName: 'Summary',
            renderCell: (params) => (
                <Link to={`/pat-bill-summary/${params.row.id}/`} className="btn btn-warning">
                    IP Bill
                </Link>
            ),
            width: 100,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row table-responsive">
                <div className='col-md-12 col-12 mb-2'>
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th>Patient ID</th>
                            <th>Patient Name</th>
                            <th>Gender</th>
                            <th>D.O.B/Age</th>
                            <th>Mobile</th>
                            <th>Regd. On</th>
                        </tr>
                        </thead>
                        <tbody>
                        {patientData.map((patientData, index) => (
                            <tr key={index}>
                                <td>
                                    <Link to={`/edit-patient/${patientData.id}`}
                                          target="_blank">{patientData.pat_id}</Link></td>
                                <td>{patientData.patient}</td>
                                <td>{patientData.gender}</td>
                                <td>{patientData.age}</td>
                                <td>{patientData.mobile}</td>
                                <td>{patientData.add_date}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <div style={{height: "100%", width: "100%"}}>
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                    className="fa-solid fa-calendar-days"
                    aria-hidden="true" style={{color: 'red'}}></i> OP Billing Details</h3>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}
                          rows={rows}
                          columns={columns}
                          pageSize={10}
                          slots={{toolbar: GridToolbar}}
                          autoHeight
                />
            </div>
            <div style={{height: '100%', width: '100%'}} className="mt-4">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                    className="fa-solid fa-calendar-days"
                    aria-hidden="true" style={{color: 'red'}}></i> IP Billing Details</h3>
                <DataGrid
                    className="mt-4"
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: 'primary.light',
                        '& .MuiDataGrid-cell:hover': {
                            color: 'primary.main',
                        },
                    }}
                    rows={rows1}
                    columns={columns1}
                    pageSize={10}
                    slots={{toolbar: GridToolbar}}
                    autoHeight
                />
            </div>
        </section>
    );
};
export default BillDetailsPat;
